let languages = [
    {
        name: 'Yoruba'
    },
    {
        name: 'English'
    },
    {
        name: 'Hausa'
    },
    {
        name: 'Igbo'
    },
    {
        name: 'Pidgin English'
    },
    {
        name: 'French'
    },
    {
        name: 'Tiv'
    },
    {
        name: 'Izon'
    },
    {
        name: 'Fulfulde'
    },
    {
        name: 'Efik-Ibibio'
    },
    {
        name: 'Ijaw-Izon'
    },
    {
        name: 'Ijaw'
    },
    {
        name: 'Urhobo'
    },
    {
        name: 'Sign Language (English)'
    },
    {
        name: 'Sign Language (Hausa)'
    },
    {
        name: 'Kanuri'
    },
    {
        name: 'Edo'
    },
    {
        name: 'Igala'
    },
    {
        name: 'German'
    },
    {
        name: 'Nupe-Ebira'
    },
    {
        name: 'Birom'
    },
    {
        name: 'Idoma'
    },
    {
        name: 'Itsekiri'
    },
    {
        name: 'British English'
    },
    {
        name: 'Spanish'
    },
    {
        name: 'Mandarin'
    }
];

export default languages;
